/** Strings owned by `src/features/statistics/` — WP-09's statistics
 * elements (`StatsPanel`, `StatsGrid`, `CompareChart`, `RangePicker`). */
export const statistics = {
  panelType: {
    series: 'Series',
    sessions: 'Sessions',
    availability: 'Availability',
  },
  status: {
    forbidden: 'You are not allowed to see this.',
    insufficientData:
      'Not enough people have data yet to show this group without identifying anyone.',
    noMetrics: 'No metrics in this range.',
    noData: 'No data in this range.',
    noSessions: 'No sessions in this range.',
    noAvailability: 'No data recorded at all.',
    loadFailed: 'Could not load this panel: {{message}}',
  },
  target: {
    you: 'You',
    department: 'Department {{name}}',
    company: 'Company {{name}}',
  },
  table: {
    date: 'Date',
    type: 'Type',
    duration: 'Duration',
    calories: 'Calories',
    avgHeartRate: 'Avg HR',
    minutes: '{{count}} min',
    metric: 'Metric',
    source: 'Source',
    first: 'First',
    last: 'Last',
    days: 'Days',
  },
  detailLink: 'View details',
  range: {
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    thisWeek: 'This week',
    thisMonth: 'This month',
    custom: 'Custom…',
    from: 'From',
    to: 'To',
  },
} as const;
